module.exports = __webpack_public_path__ + "static/kenneth-bailey-c47948bae02d234781cf35e5fc8c2ecf.jpg";